<template>
  <Breadcrumbs
      title="Create Dispatch"
      :breadcrumbs="[
      { label: 'Stock', path: '' },
      { label: 'Dispatch', path: '/dispatch' },
      { label: 'Create Dispatch', path: '/new-dispatch' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <newDispatch/>
    </div>
  </div>
</template>

<script>
import newDispatch from './newDistpatchForm.vue'
export default {
  name: 'indexList',
  components: {
    newDispatch
  },
}
</script>